import turnServiceSagas from 'Turn/services/sagas';
import { all } from 'redux-saga/effects';
import aptSagas from 'services/sagas';
export default function* rootSaga() {
  yield all([
    aptSagas(),
    turnServiceSagas(),
  ]);
}
